import { render } from "./DeviceInfo.vue?vue&type=template&id=4a460ba4&bindings={\"machine\":\"props\",\"hide\":\"props\",\"hidden\":\"options\"}"
import script from "./DeviceInfo.vue?vue&type=script&lang=js"
export * from "./DeviceInfo.vue?vue&type=script&lang=js"
script.render = render

export default script